import {
  getRequestTransportErrorMessage,
  getSafeServerErrorMessage,
} from '#/utils/requestError';

const CODE_MESSAGES = {
  SN_PRODUCT_CODE_DUPLICATED: '產品代碼已存在，請改用其他代碼',
  SN_PRODUCT_MAPPING_CUSTOMER_REQUIRED: '啟用前請先指定客戶',
  SN_PRODUCT_MAPPING_CUSTOMER_INVALID: '客戶不可用，請重新選擇',
  SN_PRODUCT_MAPPING_CUSTOMER_PREFIX_MISMATCH: '產品代碼與客戶的 SN 前綴不符',
  SN_PRODUCT_MAPPING_CUSTOMER_IMMUTABLE: '啟用後不可改客戶',
  SN_PRODUCT_MAPPING_LIFECYCLE_MANAGED: '狀態請改走啟用或停用',
  SN_PRODUCT_MAPPING_STATUS_INVALID_FOR_ACTIVATE: '目前狀態不能啟用',
  SN_PRODUCT_MAPPING_STATUS_INVALID_FOR_DEACTIVATE: '目前狀態不能停用',
  SN_PRODUCT_MAPPING_DELETE_FORBIDDEN: '只有待指定可以刪除',
  SN_PRODUCT_MAPPING_NOT_AVAILABLE: '待指定的對照還不能用於售後',
  RESOURCE_VERSION_CONFLICT: '資料已被他人修改，請重新載入後再試',
  UPDATED_AT_REQUIRED: '缺少更新時間，請重新載入後再試',
  REQUEST_BODY_INVALID: '送出的內容不符合格式',
  SN_MAPPING_INSPECTION_KIND_IDS_REQUIRED: '缺少檢測種類清單',
  SN_MAPPING_INSPECTION_KIND_ID_REQUIRED: '檢測種類清單含有空值',
  SN_MAPPING_INSPECTION_KIND_DUPLICATED: '檢測種類重複選取',
  INSPECTION_KIND_NOT_FOUND: '有檢測種類已不存在，請重新選擇',
  SN_MAPPING_INSPECTION_KIND_NOT_ACTIVE: '新加入的檢測種類不是啟用中，請重新選擇',
};

export function getSnProductMappingApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const serverMessage = getSafeServerErrorMessage(error, fallback);
  if (serverMessage) {
    return serverMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;
  if (code && CODE_MESSAGES[code]) {
    return data?.message || CODE_MESSAGES[code];
  }

  if (error?.response?.status === 404) {
    return data?.message || '找不到 物料序號';
  }

  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message;
  }

  return fallback;
}

export function isSnProductMappingVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}

export function shouldReloadSnProductMappingInspectionKinds(error) {
  const status = error?.response?.status;
  const code = error?.response?.data?.code;
  return status === 409
    || code === 'INSPECTION_KIND_NOT_FOUND'
    || code === 'SN_MAPPING_INSPECTION_KIND_NOT_ACTIVE';
}
